import React from "react";

const DigitalManagmentMain = () => {
    return (
        <div>
            <div className="">
                {/* LEFT DIV ******* */}

                <div className="col-lg-12 col-md-12 col-sm-12">
                    <h3 className="text-primary ml-5">Digital Adoptoin</h3>
                    <div>
                        <table class="table text-left table-bordered">
                            <thead
                                className="text-dark text-center"
                                style={{ background: "#F5C4AF" }}
                            >
                                <tr>
                                    <th scope="col" style={{ width: "12%" }}>
                                        Paramters
                                    </th>
                                    <th
                                        // colSpan={2}
                                        className="text-center"
                                        scope="col"
                                        style={{ width: "85%" }}
                                    >
                                        Observations
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        scope="row"
                                        className=" m-2"
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                        }}
                                    >
                                        Lorem ipsum dolor sit
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        scope="row"
                                        className=" m-2"
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                        }}
                                    >
                                        Lorem ipsum dolor sit
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        scope="row"
                                        className=" m-2"
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                        }}
                                    >
                                        Lorem ipsum dolor sit
                                    </td>
                                    <td
                                        style={{
                                            borderBottom: "5px solid #f5c4af",
                                            borderLeft: "5px solid #f5c4af",
                                        }}
                                    >
                                        Jacob Lorem ipsum dolor sit amet Lorem
                                        ipsum, dolor sit amet consectetur
                                        adipisicing elit. In provident ex odio.
                                        Error at commodi asperiores dolores quo
                                        dolor porro.
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="row mx-0">
                    <div className="col-3">
                        <h3 className="text-primary text-center">
                            Finicial Managment
                        </h3>
                        <div className="text-center bg-warning">
                            <p>Attrution FY2022</p>
                            <h2>5%</h2>
                            <p>Benchmark 0%</p>
                        </div>
                        <div className="text-center bg-warning">
                            <p>Attrution FY2022</p>
                            <h2>5%</h2>
                            <p>Benchmark 0%</p>
                        </div>
                        <div className="text-center bg-warning">
                            <p>Attrution FY2022</p>
                            <h2>5%</h2>
                            <p>Benchmark 0%</p>
                        </div>
                    </div>

                    <div className="col-9">
                        <div>
                            <table class="table text-left table-bordered">
                                <thead
                                    className="text-dark text-center"
                                    style={{ background: "#F5C4AF" }}
                                >
                                    <tr>
                                        <th
                                            scope="col"
                                            style={{ width: "12%" }}
                                        >
                                            Paramters
                                        </th>
                                        <th
                                            // colSpan={2}
                                            className="text-center"
                                            scope="col"
                                            style={{ width: "85%" }}
                                        >
                                            Observations
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                            Lorem ipsum, dolor sit amet
                                            consectetur adipisicing elit. In
                                            provident ex odio. Error at commodi
                                            asperiores dolores quo dolor porro.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                            Lorem ipsum, dolor sit amet
                                            consectetur adipisicing elit. In
                                            provident ex odio. Error at commodi
                                            asperiores dolores quo dolor porro.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            scope="row"
                                            className=" m-2"
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                            }}
                                        >
                                            Lorem ipsum dolor sit
                                        </td>
                                        <td
                                            style={{
                                                borderBottom:
                                                    "5px solid #f5c4af",
                                                borderLeft: "5px solid #f5c4af",
                                            }}
                                        >
                                            Jacob Lorem ipsum dolor sit amet
                                            Lorem ipsum, dolor sit amet
                                            consectetur adipisicing elit. In
                                            provident ex odio. Error at commodi
                                            asperiores dolores quo dolor porro.
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DigitalManagmentMain;
